import { jsx as s, jsxs as l } from "react/jsx-runtime";
import { clsx as c } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIIcon as p } from "../../icon/roche-icon.js";
import { SortOrder as o } from "../../responsive-table/roche-responsive-table.types.js";
import e from "./roche-diagnostics-header.module.scss.js";
const S = ({
  columns: a,
  sortColumnId: r,
  sortOrder: t = o.ASCENDING,
  onSortChange: d,
  sortOrderLabels: h
}) => /* @__PURE__ */ s("div", { className: e["diagnostics-header"], children: a.map(({ id: n, label: m }) => {
  const i = n === r, N = i && t === o.ASCENDING ? o.DESCENDING : o.ASCENDING;
  return /* @__PURE__ */ l(
    "button",
    {
      type: "button",
      className: c(
        e["diagnostics-header__button"],
        i && e["diagnostics-header__button--active"]
      ),
      onClick: () => d(n, N),
      children: [
        m,
        i && /* @__PURE__ */ s("span", { className: e["diagnostics-header__visually-hidden"], children: h[t] }),
        /* @__PURE__ */ s(
          "span",
          {
            className: c(
              e["diagnostics-header__icon"],
              i && t === o.ASCENDING && e["diagnostics-header__icon--ascending"]
            ),
            children: /* @__PURE__ */ s(p, { icon: "chevron-down", width: "16px", decorative: !0 })
          }
        )
      ]
    },
    n
  );
}) });
export {
  S as RocheUIDiagnosticsHeader
};
